import _regeneratorRuntime from "C:\\kugi rdf\\portalkugi07022022\\node_modules\\react-scripts\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { AsyncSerialScheduler } from "./_scheduler";
import Observable from "./observable";
import unsubscribe from "./unsubscribe";

function scan(accumulator, seed) {
  return function (observable) {
    return new Observable(function (observer) {
      var accumulated;
      var index = 0;
      var scheduler = new AsyncSerialScheduler(observer);
      var subscription = observable.subscribe({
        complete: function complete() {
          scheduler.complete();
        },
        error: function error(_error) {
          scheduler.error(_error);
        },
        next: function next(value) {
          var _this = this;

          scheduler.schedule(function (next) {
            return __awaiter(_this, void 0, void 0,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee() {
              var prevAcc;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      prevAcc = index === 0 ? typeof seed === "undefined" ? value : seed : accumulated;
                      _context.next = 3;
                      return accumulator(prevAcc, value, index++);

                    case 3:
                      accumulated = _context.sent;
                      next(accumulated);

                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));
          });
        }
      });
      return function () {
        return unsubscribe(subscription);
      };
    });
  };
}

export default scan;